import axios from 'axios'
import store from 'store'
import { notification } from 'ant-design-vue'
import { reject } from 'lodash'

const apiClient = axios.create({
    baseURL: '/api',
    // timeout: 1000,
    // headers: { 'X-Custom-Header': 'foobar' }
})

apiClient.interceptors.request.use(request => {
    const accessToken = encodeURI(store.get('accessToken'))
    if (accessToken) {
        request.headers.Authorization = `Bearer ${accessToken}`
        request.headers.AccessToken = accessToken
    }

    // para os ws do SAGA 
    //if (GlobalConfig.sagaAppToken) {
    //    request.headers['App-Token'] = GlobalConfig.sagaAppToken
    //}
    
    //console.log("GlobalConfig");
    //console.log(GlobalConfig);
  
    return request
})

apiClient.interceptors.response.use(undefined, error => {
    // Errors handling
    const { response } = error
    const { data, status } = response

    if (status >= 400 && status < 500) {
        return Promise.reject(error)
    }

    if (data) {
        notification.warning({
            message: data.mensagem,
        })
    }
})


export default apiClient
